import Vue from 'vue'
import axios from 'axios'

function responseNotifyWrapper(response) {
  if (response && response.data && response.data.exception) {
    const report = response.data
    if (report && report.trace && Array.isArray(report.trace)) {
      report.trace = [report.trace[0], '...']
    }
    Vue.notify({
      group: 'global',
      type: 'exception',
      text: JSON.stringify(report, null, 2),
      duration: 15000
    })
    return false
  }
  if (response && response.data && response.data.message) {
    if (response.status === 200 && response.data.error === false) {
      Vue.notify({
        group: 'global',
        title: response.statusCode,
        type: 'success',
        text: response.data.message
      })
    } else if (response.data.error === true) {
      Vue.notify({
        group: 'global',
        title: response.statusCode,
        type: 'error',
        text: response.data.message
      })
    } else if (response.data.message && response.status !== 200) {
      Vue.notify({
        group: 'global',
        title: response.statusCode,
        type: 'warning',
        text: response.data.message
      })
    }
  }
}

const axiosClient = axios.create()

axiosClient.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  axiosClient.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
  console.error(
    'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token'
  )
}
axiosClient.interceptors.response.use(
  function (response) {
    responseNotifyWrapper(response)
    return response
  },
  function (error) {
    responseNotifyWrapper(error.response)
    return Promise.reject(error)
  }
)

export { axiosClient }
